import { render, staticRenderFns } from "./ponitActive.vue?vue&type=template&id=7117fa0b&scoped=true"
import script from "./ponitActive.vue?vue&type=script&lang=js"
export * from "./ponitActive.vue?vue&type=script&lang=js"
import style0 from "./ponitActive.vue?vue&type=style&index=0&id=7117fa0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7117fa0b",
  null
  
)

export default component.exports